import React, { PureComponent, ReactElement } from 'react';

import { Copyright, Modal } from '@philips-emr/tws-components';
import { ModalType, ThemeTonalRange } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, expression } from '@philips-emr/tws-core/lib/component/prop-types';
import { CloseEvent } from '@philips-emr/tws-core/lib/component/types';

import { HpmsAboutApi } from '../../api';

interface HpmsAboutProps {
  applicationName: string,
  onCloseModalAbout?: (event: CloseEvent) => void,
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsAboutApi })
export default class HpmsAbout extends PureComponent<HpmsAboutProps> {

  static propTypes = {
    applicationName: expression,
    onCloseModalAbout: eventListener,
  };

  public render(): ReactElement {
    const { applicationName, onCloseModalAbout } = this.props;

    return (
      <Modal onClose = {onCloseModalAbout} theme={ThemeTonalRange.BRIGHT} type={ModalType.DIALOG}>
        <Copyright applicationName={applicationName} ></Copyright>
      </Modal>);
  }

}

